/**
 * Cart Drawer — Notary of America
 * Slides in from right (desktop) / bottom (mobile)
 * Fetches product tags to detect single-only items
 */
(function() {
  'use strict';

  // ── Styles ────────────────────────────────────────────────────────────────────

  function injectStyles() {
    if (document.getElementById('noa-cart-drawer-styles')) return;
    var css = [
      '@keyframes noa-drawer-in-right { from{transform:translateX(100%)} to{transform:translateX(0)} }',
      '@keyframes noa-drawer-in-bottom { from{transform:translateY(100%)} to{transform:translateY(0)} }',
      '@keyframes noa-overlay-in { from{opacity:0} to{opacity:1} }',

      '#noa-cart-overlay { display:none; position:fixed; inset:0; background:rgba(0,0,0,.45); z-index:9998; }',
      '#noa-cart-overlay.noa-open { display:block; animation:noa-overlay-in .2s ease both; }',

      '#noa-cart-drawer { display:none; position:fixed; top:0; right:0; width:380px; max-width:100vw; height:100%; background:#fff; z-index:10000; flex-direction:column; box-shadow:-4px 0 24px rgba(0,0,0,.12); pointer-events:auto; }',
      '#noa-cart-drawer.noa-open { display:flex; animation:noa-drawer-in-right .3s cubic-bezier(.25,.46,.45,.94) both; }',

      '#noa-drawer-header { display:flex; align-items:center; justify-content:space-between; padding:16px 20px; border-bottom:1px solid #e8e8e8; flex-shrink:0; }',
      '#noa-drawer-header-title { display:flex; align-items:center; gap:9px; font-size:16px; font-weight:600; color:#1a1a1a; }',
      '#noa-drawer-check { width:24px; height:24px; border-radius:50%; background:#2e6b2e; display:flex; align-items:center; justify-content:center; flex-shrink:0; }',
      '#noa-drawer-close { width:32px; height:32px; border-radius:6px; border:1px solid #e0e0e0; background:#f8f8f8; cursor:pointer; display:flex; align-items:center; justify-content:center; color:#555; transition:background .15s; }',
      '#noa-drawer-close:hover { background:#efefef; }',

      '#noa-drawer-body { flex:1; overflow-y:auto; padding:20px; }',

      '#noa-added-item { display:flex; flex-direction:column; gap:0; margin-bottom:16px; }',
      '.noa-cart-item { display:flex; gap:12px; padding:12px 0; border-bottom:1px solid #f0f0f0; }',
      '.noa-cart-item:first-child { padding-top:0; }',
      '.noa-cart-item img { width:64px; height:64px; object-fit:contain; border-radius:6px; background:#f5f5f5; padding:4px; flex-shrink:0; }',
      '.noa-cart-item--new { background:#f0f7ff; margin:0 -20px; padding:12px 20px; border-bottom:1px solid #dce8f5; }',
      '.noa-cart-item--new:first-child { padding-top:12px; }',
      '.noa-item-info { flex:1; min-width:0; }',
      '.noa-item-name { font-size:14px; font-weight:600; color:#1a1a1a; margin:0 0 4px; line-height:1.3; }',
      '.noa-item-variant { font-size:12px; color:#777; margin:0 0 6px; }',
      '.noa-item-bottom { display:flex; justify-content:space-between; align-items:center; margin-top:4px; }',
      '.noa-item-price { font-size:15px; font-weight:600; color:#1a3a6b; }',
      '.noa-item-remove { background:none; border:none; color:#aaa; font-size:12px; cursor:pointer; padding:0; text-decoration:underline; transition:color .15s; }',
      '.noa-item-remove:hover { color:#c0392b; }',
      '.noa-cart-item.noa-removing { opacity:0; transition:opacity .2s ease; }',
      '.noa-empty-cart { text-align:center; padding:40px 20px; color:#888; font-size:14px; }',
      '.noa-empty-cart p { margin:8px 0 0; }',

      '.noa-qty-control { display:flex; align-items:center; gap:0; border:1.5px solid #e0e0e0; border-radius:6px; overflow:hidden; height:28px; }',
      '.noa-qty-btn { width:28px; height:28px; border:none; background:#f5f5f5; color:#1a3a6b; font-size:16px; font-weight:500; cursor:pointer; display:flex; align-items:center; justify-content:center; transition:background .15s; flex-shrink:0; line-height:1; }',
      '.noa-qty-btn:hover { background:#e8edf5; }',
      '.noa-qty-btn:disabled { opacity:.35; cursor:not-allowed; }',
      '.noa-qty-num { width:32px; text-align:center; font-size:13px; font-weight:600; color:#1a1a1a; border-left:1.5px solid #e0e0e0; border-right:1.5px solid #e0e0e0; height:100%; display:flex; align-items:center; justify-content:center; }',

      '#noa-cart-summary { background:#f8f9fc; border-radius:8px; padding:14px 16px; margin-bottom:16px; }',
      '.noa-summary-row { display:flex; justify-content:space-between; font-size:13px; color:#666; margin-bottom:6px; }',
      '.noa-summary-row:last-child { margin-bottom:0; padding-top:8px; border-top:1px solid #e8e8e8; font-size:15px; font-weight:600; color:#1a1a1a; }',

      '#noa-drawer-footer { padding:16px 20px; border-top:1px solid #e8e8e8; flex-shrink:0; display:flex; flex-direction:column; gap:10px; }',
      '#noa-btn-checkout { display:block; background:#1a3a6b; color:#fff; text-align:center; padding:14px; border-radius:6px; font-size:15px; font-weight:600; text-decoration:none; border:none; cursor:pointer; transition:background .15s; }',
      '#noa-btn-checkout:hover { background:#152d54; color:#fff; }',
      '#noa-btn-continue { display:block; background:#fff; color:#1a3a6b; text-align:center; padding:13px; border-radius:6px; font-size:14px; font-weight:500; border:1.5px solid #d0dae8; cursor:pointer; transition:background .15s; text-decoration:none; }',
      '#noa-btn-continue:hover { background:#f4f7fb; }',

      '@media (max-width:600px) {',
      '  #noa-cart-drawer { top:auto; bottom:0; right:0; left:0; width:100%; height:auto; max-height:88vh; border-radius:16px 16px 0 0; box-shadow:0 -4px 24px rgba(0,0,0,.12); }',
      '  #noa-cart-drawer.noa-open { animation:noa-drawer-in-bottom .3s cubic-bezier(.25,.46,.45,.94) both; }',
      '  #noa-drawer-body { max-height:55vh; }',
      '}',
    ].join('\n');
    var s = document.createElement('style');
    s.id = 'noa-cart-drawer-styles';
    s.textContent = css;
    document.head.appendChild(s);
  }

  // ── Build drawer HTML ─────────────────────────────────────────────────────────

  function buildDrawer() {
    var overlay = document.createElement('div');
    overlay.id = 'noa-cart-overlay';
    document.body.appendChild(overlay);

    var drawer = document.createElement('div');
    drawer.id = 'noa-cart-drawer';
    drawer.setAttribute('role', 'dialog');
    drawer.setAttribute('aria-label', 'Shopping cart');
    drawer.innerHTML = [
      '<div id="noa-drawer-header">',
        '<div id="noa-drawer-header-title">',
          '<div id="noa-drawer-check">',
            '<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>',
          '</div>',
          'Added to cart',
        '</div>',
        '<button id="noa-drawer-close" type="button" aria-label="Close cart">',
          '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>',
        '</button>',
      '</div>',
      '<div id="noa-drawer-body">',
        '<div id="noa-added-item"></div>',
        '<div id="noa-cart-summary"></div>',
      '</div>',
      '<div id="noa-drawer-footer">',
        '<a id="noa-btn-checkout" href="/checkout">Proceed to checkout</a>',
        '<button id="noa-btn-continue" type="button">Continue shopping</button>',
      '</div>',
    ].join('');
    document.body.appendChild(drawer);

    document.getElementById('noa-drawer-close').addEventListener('click', closeDrawer);
    document.getElementById('noa-btn-continue').addEventListener('click', closeDrawer);
    overlay.addEventListener('click', closeDrawer);

    // Checkout gate: wait for cert CDN capture before navigating
    // certificate-upload.js sets window._noaCertCapturePromise when session
    // is 'pending'. We wait on it (max 4s) so the order gets the real CDN URL.
    document.getElementById('noa-btn-checkout').addEventListener('click', function(e) {
      var capture = window._noaCertCapturePromise;
      if (!capture) return;
      e.preventDefault();
      var btn = this;
      btn.textContent = 'Preparing checkout…';
      btn.style.opacity = '0.7';
      btn.style.pointerEvents = 'none';
      var timeout = new Promise(function(resolve) { setTimeout(resolve, 4000); });
      Promise.race([capture, timeout]).then(function() {
        window._noaCertCapturePromise = null;
        window.location.href = '/checkout';
      });
    });
  }

  // ── Open / close ──────────────────────────────────────────────────────────────

  function openDrawer() {
    document.getElementById('noa-cart-drawer').classList.add('noa-open');
    document.getElementById('noa-cart-overlay').classList.add('noa-open');
    document.body.style.overflow = 'hidden';
  }

  function closeDrawer() {
    document.getElementById('noa-cart-drawer').classList.remove('noa-open');
    document.getElementById('noa-cart-overlay').classList.remove('noa-open');
    document.body.style.overflow = '';
  }

  // ── Product tag cache ─────────────────────────────────────────────────────────

  var tagCache = {};

  function getProductTags(handle, productId) {
    if (tagCache[productId] !== undefined) {
      return Promise.resolve(tagCache[productId]);
    }
    return fetch('/products/' + handle + '.js')
      .then(function(r) { return r.json(); })
      .then(function(p) {
        var tags = (p.tags || []).join(',').toLowerCase();
        tagCache[productId] = tags;
        return tags;
      })
      .catch(function() { return ''; });
  }

  // ── Render a single cart item ─────────────────────────────────────────────────

  function renderItem(cartItem, isNew, tags) {
    var imgSrc = cartItem.image || '';
    var variantTitle = (cartItem.variant_title && cartItem.variant_title !== 'Default Title')
      ? '<p class="noa-item-variant">' + cartItem.variant_title + '</p>' : '';
    var singleOnly = tags.indexOf('single-only') !== -1;

    var qtyHTML = singleOnly
      ? '<span style="font-size:12px;color:#888;">Qty: 1 &mdash; limit 1 per order</span>'
      : '<div class="noa-qty-control">' +
          '<button class="noa-qty-btn noa-qty-minus" type="button" data-key="' + cartItem.key + '" data-qty="' + cartItem.quantity + '" ' + (cartItem.quantity <= 1 ? 'disabled' : '') + '>&#8722;</button>' +
          '<span class="noa-qty-num">' + cartItem.quantity + '</span>' +
          '<button class="noa-qty-btn noa-qty-plus" type="button" data-key="' + cartItem.key + '" data-qty="' + cartItem.quantity + '">&#43;</button>' +
        '</div>';

    return [
      '<div class="noa-cart-item' + (isNew ? ' noa-cart-item--new' : '') + '" data-key="' + cartItem.key + '">',
        imgSrc ? '<img src="' + imgSrc + '" alt="' + cartItem.product_title + '">'
               : '<div style="width:64px;height:64px;background:#f5f5f5;border-radius:6px;flex-shrink:0;"></div>',
        '<div class="noa-item-info">',
          '<p class="noa-item-name">' + cartItem.product_title + '</p>',
          variantTitle,
          '<div class="noa-item-bottom">',
            qtyHTML,
            '<span class="noa-item-price" data-key="' + cartItem.key + '">' + formatMoney(cartItem.final_line_price) + '</span>',
          '</div>',
          '<button class="noa-item-remove" data-key="' + cartItem.key + '" type="button">Remove</button>',
        '</div>',
      '</div>',
    ].join('');
  }

  // ── Populate drawer ───────────────────────────────────────────────────────────

  function populateDrawer(item, cart) {
    var itemEl    = document.getElementById('noa-added-item');
    var summaryEl = document.getElementById('noa-cart-summary');

    // Fetch tags for all items in parallel then render
    Promise.all(
      cart.items.map(function(ci) { return getProductTags(ci.handle, ci.product_id); })
    ).then(function(tagsArray) {
      var html = '';
      cart.items.forEach(function(ci, idx) {
        html += renderItem(ci, ci.variant_id === item.variant_id, tagsArray[idx] || '');
      });
      itemEl.innerHTML = html;

      var count = cart.item_count;
      summaryEl.innerHTML = [
        '<div class="noa-summary-row"><span>Shipping</span><span style="color:#888;">Calculated at checkout</span></div>',
        '<div class="noa-summary-row"><span>Subtotal (' + count + ' item' + (count !== 1 ? 's' : '') + ')</span><span>' + formatMoney(cart.total_price) + '</span></div>',
      ].join('');

      // Update cart count in header
      document.querySelectorAll('.cart-count').forEach(function(el) {
        el.textContent = count;
        el.classList.toggle('hidden-count', count === 0);
      });

      // Wire buttons
      wireButtons(cart);
    });
  }

  // ── Wire drawer buttons ───────────────────────────────────────────────────────

  function changeQty(key, newQty) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: newQty })
    })
    .then(function(r) { return r.json(); })
    .then(function(cart) {
      if (cart.item_count === 0) {
        document.getElementById('noa-added-item').innerHTML =
          '<div class="noa-empty-cart"><svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="#ccc" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"/></svg><p>Your cart is empty</p></div>';
        document.getElementById('noa-cart-summary').innerHTML = '';
        document.querySelectorAll('.cart-count').forEach(function(el) {
          el.textContent = '0'; el.classList.add('hidden-count');
        });
      } else {
        populateDrawer(cart.items[0], cart);
      }
    })
    .catch(function(err) { console.error('Cart update error:', err); });
  }

  function wireButtons(cart) {
    document.querySelectorAll('.noa-item-remove').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var key = this.getAttribute('data-key');
        var el = document.querySelector('.noa-cart-item[data-key="' + key + '"]');
        if (el) el.classList.add('noa-removing');
        changeQty(key, 0);
      });
    });

    document.querySelectorAll('.noa-qty-minus').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var key = this.getAttribute('data-key');
        var cur = parseInt(this.getAttribute('data-qty')) || 1;
        if (cur > 1) changeQty(key, cur - 1);
      });
    });

    document.querySelectorAll('.noa-qty-plus').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var key = this.getAttribute('data-key');
        var cur = parseInt(this.getAttribute('data-qty')) || 1;
        changeQty(key, cur + 1);
      });
    });
  }

  // ── Money formatter ───────────────────────────────────────────────────────────

  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  // ── Intercept Add to Cart ─────────────────────────────────────────────────────

  function interceptAddToCart() {
    function wireButton() {
      var btn = document.getElementById('AddToCart');
      if (!btn || btn.getAttribute('data-noa-wired')) return;
      btn.setAttribute('data-noa-wired', '1');

      btn.addEventListener('click', function(e) {
        e.preventDefault();

        var form = document.getElementById('AddToCartForm');
        if (!form) return;

        // Certificate validation — check before proceeding
        if (form.getAttribute('data-requires-cert') === 'true') {
          var certFileInput = form.querySelector('input[type="file"]#noa-cert-file-input');
          var hasFile    = !!(certFileInput && certFileInput.files && certFileInput.files.length > 0);
          var hasUrl     = !!document.getElementById('noa-cert-url-input');
          var sessionUrl = '';
          try { sessionUrl = sessionStorage.getItem('noa_cert_url') || ''; } catch(err) {}
          // 'pending' means file was selected client-side but not yet saved to Shopify CDN —
          // treat it as valid here since the file is in the input and will be submitted below
          var hasPending = sessionUrl === 'pending';
          var hasSession = !!sessionUrl && sessionUrl !== 'pending';

          if (!hasFile && !hasUrl && !hasSession && !hasPending) {
            // Show error via certificate upload module
            var errorEl = document.getElementById('noa-cert-error');
            var errorMsg = document.getElementById('noa-cert-error-msg');
            if (errorEl && errorMsg) {
              errorMsg.textContent = 'Please upload your commission certificate before adding to cart.';
              errorEl.classList.add('noa-show');
              errorEl.scrollIntoView({ behavior: 'smooth', block: 'center' });
            } else {
              alert('Please upload your commission certificate before adding to cart.');
            }
            return;
          }
        }

        var formData = new FormData(form);
        var id = formData.get('id');
        if (!id) return;

        var btnText  = document.getElementById('AddToCartText');
        var origText = btnText ? btnText.textContent : 'Add to Cart';
        if (btnText) btnText.textContent = 'Adding...';
        btn.disabled = true;

        var isSingleOnly = form.getAttribute('data-single-only') === 'true';

        // ── File upload via AJAX ───────────────────────────────────────────────────
        // Shopify's /cart/add.js silently ignores file inputs. Instead we POST the
        // file to Shopify's /cart/add endpoint with only the file field, which stores
        // the file and returns the CDN URL in the cart item properties. We then strip
        // the file input, inject the URL as a hidden property, and do a normal AJAX add.
        // This keeps the customer on the page with the cart drawer opening normally.
        var certFileInputForAdd = form.querySelector('input[type="file"]#noa-cert-file-input');
        var hasRealFileForAdd = !!(certFileInputForAdd && certFileInputForAdd.files && certFileInputForAdd.files.length > 0);
        var requiresCert = form.getAttribute('data-requires-cert') === 'true';

        if (requiresCert && hasRealFileForAdd) {
          // Step 1: submit the full form (with file) to /cart/add — this stores the
          // file on Shopify CDN. We use a hidden iframe so the page doesn't reload.
          var file = certFileInputForAdd.files[0];
          var uploadData = new FormData();
          uploadData.append('form_type', 'product');
          uploadData.append('utf8', '✓');
          uploadData.append('id', formData.get('id'));
          // Quantity 0 trick: add with qty 0 so Shopify processes the file but we
          // don't end up with a duplicate item — we'll do the real add in step 2.
          // Actually Shopify doesn't support qty 0. Instead: upload via full form
          // POST to a hidden iframe, then immediately remove that item.
          //
          // Simpler approach: use fetch with FormData including the file directly
          // against /cart/add.js — even though Shopify ignores file inputs in JSON
          // mode, it DOES process them in multipart mode. The trick is to NOT set
          // Accept: application/json so Shopify treats it as a browser form submit
          // and returns a redirect rather than JSON — but we just care about the
          // side effect (file stored) and then fetch /cart.js to get the CDN URL.
          var fileUploadData = new FormData(form);
          // Ensure the file input has the right name for Shopify to process it
          // The file input already has name=properties[Commission Certificate Required:]
          // from certificate-upload.js when a file is selected.

          if (btnText) btnText.textContent = 'Uploading...';

          // Post as multipart (no Accept:json header) — Shopify processes the file
          // and redirects. We use no-redirect mode to suppress the page navigation.
          fetch('/cart/add', {
            method: 'POST',
            body: fileUploadData,
            redirect: 'manual'
          })
          .then(function() {
            // File is now on Shopify CDN. Fetch cart to get the CDN URL.
            return fetch('/cart.js', { headers: { 'Accept': 'application/json' } });
          })
          .then(function(r) { return r.json(); })
          .then(function(cart) {
            var PROP = 'Commission Certificate Required:';
            var cdnUrl = '';
            var addedItemKey = '';
            cart.items.forEach(function(item) {
              if (item.properties && item.properties[PROP]) {
                var u = item.properties[PROP];
                if (typeof u === 'string' && u.indexOf('cdn.shopify.com') !== -1) {
                  cdnUrl = u;
                  addedItemKey = item.key;
                }
              }
            });

            if (!cdnUrl) throw new Error('CDN URL not found after upload');

            // Save CDN URL to session
            try { sessionStorage.setItem('noa_cert_url', cdnUrl); } catch(e) {}
            window._noaCertCapturePromise = null;

            // Step 2: remove the temp item Shopify added, then re-add with correct quantity
            return fetch('/cart/change.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
              body: JSON.stringify({ id: addedItemKey, quantity: 0 })
            })
            .then(function() {
              // Step 3: do the real AJAX add with the CDN URL as a property
              var realFormData = new FormData();
              realFormData.append('id', formData.get('id'));
              realFormData.append('quantity', formData.get('quantity') || '1');
              realFormData.append('properties[' + PROP + ']', cdnUrl);
              // Copy any other properties from the form (state, etc.)
              for (var pair of formData.entries()) {
                if (pair[0] !== 'id' && pair[0] !== 'quantity' &&
                    pair[0].indexOf('properties[' + PROP) === -1 &&
                    !(pair[1] instanceof File)) {
                  realFormData.append(pair[0], pair[1]);
                }
              }
              return fetch('/cart/add.js', {
                method: 'POST',
                headers: { 'Accept': 'application/json' },
                body: realFormData
              });
            });
          })
          .then(function(r) { return r.json(); })
          .then(function(item) {
            return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
              .then(function(r) { return r.json(); })
              .then(function(cart) {
                // Update cert upload UI view link
                var cdnUrl2 = '';
                var PROP2 = 'Commission Certificate Required:';
                cart.items.forEach(function(i) {
                  if (i.properties && i.properties[PROP2]) {
                    var u = i.properties[PROP2];
                    if (typeof u === 'string' && u.indexOf('cdn.shopify.com') !== -1) cdnUrl2 = u;
                  }
                });
                if (cdnUrl2) {
                  try { sessionStorage.setItem('noa_cert_url', cdnUrl2); } catch(e) {}
                  var vl = document.getElementById('noa-cert-view-link');
                  if (vl) { vl.href = cdnUrl2; vl.style.display = 'block'; }
                }
                populateDrawer(item, cart);
                openDrawer();
                setTimeout(function() {
                  document.dispatchEvent(new CustomEvent('noa-cart-added'));
                }, 200);
                if (isSingleOnly) {
                  btn.disabled = true;
                  btn.style.opacity = '0.65';
                  btn.style.cursor = 'not-allowed';
                  if (btnText) btnText.textContent = 'Already in cart';
                } else {
                  if (btnText) btnText.textContent = origText;
                  btn.disabled = false;
                }
              });
          })
          .catch(function(err) {
            console.error('Certificate upload error:', err);
            if (btnText) btnText.textContent = origText;
            btn.disabled = false;
            // Last resort fallback: native POST
            form.setAttribute('data-noa-file-submit', 'true');
            form.submit();
          });
          return;
        }

        function doAdd() {
          fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Accept': 'application/json' },
            body: formData
          })
          .then(function(r) {
            if (!r.ok) throw new Error('Cart add failed');
            return r.json();
          })
          .then(function(item) {
            return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
              .then(function(r) { return r.json(); })
              .then(function(cart) { return { item: item, cart: cart }; });
          })
          .then(function(result) {
            populateDrawer(result.item, result.cart);
            openDrawer();
            // Fire after a tick so populateDrawer's Promise.all has resolved
            setTimeout(function() {
              document.dispatchEvent(new CustomEvent('noa-cart-added'));
            }, 200);
            if (isSingleOnly) {
              btn.disabled = true;
              btn.style.opacity = '0.65';
              btn.style.cursor = 'not-allowed';
              if (btnText) btnText.textContent = 'Already in cart';
            } else {
              if (btnText) btnText.textContent = origText;
              btn.disabled = false;
            }
          })
          .catch(function(err) {
            console.error('Cart drawer error:', err);
            if (btnText) btnText.textContent = origText;
            btn.disabled = false;
            form.submit();
          });
        }

        if (isSingleOnly) {
          fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
            .then(function(r) { return r.json(); })
            .then(function(cart) {
              var inCart = cart.items.some(function(i) { return i.variant_id === parseInt(id); });
              if (inCart) {
                btn.disabled = true;
                btn.style.opacity = '0.65';
                btn.style.cursor = 'not-allowed';
                if (btnText) btnText.textContent = 'Already in cart';
                populateDrawer(cart.items[0], cart);
                openDrawer();
              } else {
                doAdd();
              }
            })
            .catch(function() { doAdd(); });
        } else {
          doAdd();
        }
      }, false);
    }

    wireButton();
    document.addEventListener('DOMContentLoaded', wireButton);
    setTimeout(wireButton, 500);
  }

  // ── Form submit blocker ───────────────────────────────────────────────────────
  // Blocks all native form submits. The AJAX file upload path handles cert products.
  // data-noa-file-submit="true" is only set as a last-resort fallback on upload error.

  document.addEventListener('DOMContentLoaded', function() {
    var form = document.getElementById('AddToCartForm');
    if (!form) return;
    form.addEventListener('submit', function(e) {
      if (form.getAttribute('data-noa-file-submit') === 'true') {
        form.removeAttribute('data-noa-file-submit'); // one-time pass
        return; // allow native POST through
      }
      e.preventDefault();
    }, true);
  });

  // ── Init ──────────────────────────────────────────────────────────────────────

  function init() {
    injectStyles();
    buildDrawer();
    interceptAddToCart();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
